import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import OffoodLogo from "../../components/brand/OffoodLogo";
import { usePageTitle } from "../../hooks/useMeta";
import useLangNavigate from "../../hooks/useLangNavigate";

const SecurityWarning = () => {
  const { t } = useTranslation();
  usePageTitle("securityWarning");
  const navigate = useLangNavigate();

  return (
    <div className="d-flex flex-column">
      <div className="p-4">
        <OffoodLogo size="md" variant="black" onClick={() => navigate("/")} />
      </div>

      <div className="d-flex flex-column w-100 justify-content-center align-items-center p-4">
        <div className="text-center">
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className="text-danger mb-5"
            size="10x"
          />
        </div>
        <div className="text-center p1">
          <div>{t("securityWarning.message1")}</div>
          <div>{t("securityWarning.message2")}</div>
        </div>
      </div>
    </div>
  );
};

export default SecurityWarning;
